function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cmb-1{fill:#ef886c;}.cmb-2{fill:#343f4e;}.cmb-3{clip-path:url(#clip-path);}.cmb-4{fill:#ed6f46;}.cmb-5{fill:#f2efdc;}.cmb-6{clip-path:url(#clip-path-2);}"), React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  className: "cmb-1",
  d: "M78.13,31.56c-.64,0-1.28,0-1.93,0-2.59.09-5.19.4-7.77.75a30.24,30.24,0,0,1-7.7.44c-4.84-.62-9.18-2.93-13.58-4.89s-12.64-8.29-17-2.36a1.18,1.18,0,0,1-.47.38L9.09,129c12.18,13.27,34.76,19.53,47,14.07L97.86,37.47Z"
})), React.createElement("clipPath", {
  id: "clip-path-2"
}, React.createElement("path", {
  className: "cmb-1",
  d: "M133.59,31.2c.64,0,1.29,0,1.93,0,2.59.12,5.18.47,7.76.85a30.24,30.24,0,0,0,7.69.54c4.85-.55,9.22-2.8,13.65-4.71s12.75-8.11,17-2.13a1.05,1.05,0,0,0,.46.39l19.23,103.35c-12.35,13.11-35,19.06-47.19,13.44L113.79,36.84Z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cmb-2",
  d: "M28.22,151.2C14.58,147.12,1.57,140.2,0,133.28a1.49,1.49,0,0,1,0-.63l24.54-119a1.51,1.51,0,0,1,2.95.61L3.05,132.92c1.66,5.65,15.3,13,31.45,16.86,11.73,2.81,21.3,2.73,24-.17L103.31,37a1.5,1.5,0,1,1,2.79,1.11L61.22,151a1.63,1.63,0,0,1-.24.4c-4.86,5.92-20.62,2.91-27.18,1.34C32,152.26,30.08,151.76,28.22,151.2Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M63.62,31.58C51.37,27.91,23,18.8,24.61,13.52s30.26,2.69,42.52,6.36,40.6,12.78,39,18.06S75.88,35.25,63.62,31.58ZM28.33,14.64c3.44,2.53,16.27,8.1,36.16,14.05s33.67,8.36,37.93,8.13c-3.44-2.53-16.27-8.1-36.16-14S32.59,14.41,28.33,14.64Z"
}), React.createElement("path", {
  className: "cmb-1",
  d: "M78.13,31.56c-.64,0-1.28,0-1.93,0-2.59.09-5.19.4-7.77.75a30.24,30.24,0,0,1-7.7.44c-4.84-.62-9.18-2.93-13.58-4.89s-12.64-8.29-17-2.36a1.18,1.18,0,0,1-.47.38L9.09,129c12.18,13.27,34.76,19.53,47,14.07L97.86,37.47Z"
}), React.createElement("g", {
  className: "cmb-3"
}, React.createElement("path", {
  className: "cmb-4",
  d: "M83.84,42.67c-5.41-.44-10.75,1.44-11.39,1.44-2.57,0-5.13.21-7.69.44a31.77,31.77,0,0,1-7.61.18c-4.82-.7-9.19-2.91-13.6-4.81S30.77,32.07,26.64,37.3a1,1,0,0,1-.45.32L8.76,130.05c12.46,12.34,35,18.64,47,14.08L97.18,46.66S89.25,43.11,83.84,42.67Z"
})), React.createElement("path", {
  className: "cmb-5",
  d: "M92.81,27.48a7.63,7.63,0,0,0-1.23-.24A8.11,8.11,0,0,0,88,22.08a8.08,8.08,0,0,0-15-4.21,6.26,6.26,0,0,0-9.81-1.07l-.12-.05h0A6.3,6.3,0,0,0,51,13.5a6.2,6.2,0,0,0-3,1,6.18,6.18,0,0,0-2.76-1.72A6.33,6.33,0,0,0,37.32,17a7.35,7.35,0,0,0-.2,1,6.33,6.33,0,0,0-3.54,12.15,6.24,6.24,0,0,0,5-.6,8,8,0,0,0,9.49,4.7A10.34,10.34,0,0,0,66.2,35.68l.14-.09a7.88,7.88,0,0,0,7.36,2A8.08,8.08,0,0,0,85.92,42a8,8,0,0,0,2.23,1.11,8.14,8.14,0,0,0,4.66-15.59Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M90.49,44.82a9.65,9.65,0,0,1-2.75-.41,8.7,8.7,0,0,1-1.85-.8A9.49,9.49,0,0,1,72.8,39.17a9.22,9.22,0,0,1-3.63-.33,9.34,9.34,0,0,1-2.62-1.27,11.72,11.72,0,0,1-19.27-1.72,9.34,9.34,0,0,1-9.35-4.44A7.73,7.73,0,0,1,28,21.89,7.76,7.76,0,0,1,36,16.4a7.75,7.75,0,0,1,9.58-5,7.49,7.49,0,0,1,2.57,1.36A7.48,7.48,0,0,1,50,12.19a7.7,7.7,0,0,1,14.44,2.05,7.62,7.62,0,0,1,5.46-.42A7.81,7.81,0,0,1,73,15.62a9.48,9.48,0,0,1,16.41,5.71A9.47,9.47,0,0,1,92.71,26l.51.13a9.55,9.55,0,0,1-2.73,18.69Zm-4.57-4.26a1.43,1.43,0,0,1,.79.24,6.59,6.59,0,0,0,1.84.92,6.73,6.73,0,0,0,8.38-4.52,6.75,6.75,0,0,0-4.52-8.38h0a7.31,7.31,0,0,0-1-.19,1.4,1.4,0,0,1-1.19-1.1,6.65,6.65,0,0,0-2.92-4.27,1.38,1.38,0,0,1-.64-1.17,6.68,6.68,0,0,0-12.4-3.48,1.39,1.39,0,0,1-1.19.66h0a1.38,1.38,0,0,1-1.19-.65,4.86,4.86,0,0,0-7.63-.83,1.38,1.38,0,0,1-1.43.34l-.14-.05a1.41,1.41,0,0,1-.94-1.57A4.89,4.89,0,0,0,52.3,14a1.4,1.4,0,0,1-1.24.91,4.94,4.94,0,0,0-2.35.75,1.4,1.4,0,0,1-1.77-.22,4.88,4.88,0,0,0-2.14-1.34,4.94,4.94,0,0,0-6.13,3.31,4.61,4.61,0,0,0-.15.81,1.41,1.41,0,0,1-1.78,1.17,4.92,4.92,0,1,0,1.12,9A1.4,1.4,0,0,1,39,28.24a1.38,1.38,0,0,1,.84.78,6.6,6.6,0,0,0,7.85,3.89,1.38,1.38,0,0,1,1.63.78A8.93,8.93,0,0,0,65,34.91a1.46,1.46,0,0,1,.34-.36l.18-.12a1.3,1.3,0,0,1,1.77.14A6.58,6.58,0,0,0,70,36.14a6.51,6.51,0,0,0,3.4.09,1.4,1.4,0,0,1,1.66,1,6.69,6.69,0,0,0,10.11,3.61A1.34,1.34,0,0,1,85.92,40.56ZM63.11,16.75h0Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M63.62,31.58C51.37,27.91,23,18.8,24.61,13.52a1.5,1.5,0,0,1,2.94.42C29.11,16,42.47,22.1,64.49,28.69s36.54,8.83,39,8a1.51,1.51,0,0,1,2.69,1.28C104.57,43.22,75.88,35.25,63.62,31.58Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 69.43,
  cy: 65.2,
  r: 2.93
}), React.createElement("path", {
  className: "cmb-2",
  d: "M69.43,68.9a4,4,0,0,1-1.07-.15,3.73,3.73,0,0,1-2.49-4.62h0A3.71,3.71,0,0,1,73,66.26a3.71,3.71,0,0,1-3.55,2.64Zm-2.07-4.32A2.15,2.15,0,1,0,70,63.13,2.16,2.16,0,0,0,67.36,64.58Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 75.78,
  cy: 51.75,
  r: 2.74
}), React.createElement("path", {
  className: "cmb-2",
  d: "M75.78,55.21a3.35,3.35,0,0,1-1-.15,3.46,3.46,0,1,1,4.3-2.32,3.4,3.4,0,0,1-1.67,2.06A3.5,3.5,0,0,1,75.78,55.21Zm0-5.47a2,2,0,1,0,.57.08A2.24,2.24,0,0,0,75.78,49.74Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 59.08,
  cy: 53.85,
  r: 2.63
}), React.createElement("path", {
  className: "cmb-2",
  d: "M59.08,57.17a3.19,3.19,0,0,1-1-.14,3.27,3.27,0,0,1-2-1.6,3.33,3.33,0,0,1-.26-2.53h0a3.37,3.37,0,0,1,1.61-2A3.34,3.34,0,0,1,62,52.27a3.33,3.33,0,0,1,.26,2.53,3.3,3.3,0,0,1-3.18,2.37ZM57.23,53.3a1.89,1.89,0,0,0,.15,1.47,1.93,1.93,0,0,0,2.61.78,1.89,1.89,0,0,0,.94-1.15,1.93,1.93,0,0,0-2.77-2.25,1.87,1.87,0,0,0-.93,1.15Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 46.01,
  cy: 3.71,
  r: 2.93
}), React.createElement("path", {
  className: "cmb-2",
  d: "M46,7.42A3.54,3.54,0,0,1,45,7.26a3.71,3.71,0,0,1-2.49-4.61h0a3.7,3.7,0,0,1,7.1,2.12A3.71,3.71,0,0,1,46,7.42Zm0-5.87A2.16,2.16,0,0,0,44,3.09h0a2.09,2.09,0,0,0,.17,1.64,2.09,2.09,0,0,0,1.27,1,2.16,2.16,0,0,0,2.68-1.44,2.14,2.14,0,0,0-1.44-2.68A1.91,1.91,0,0,0,46,1.55ZM43.2,2.87h0Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 36.61,
  cy: 5.05,
  r: 2.63
}), React.createElement("path", {
  className: "cmb-2",
  d: "M36.61,8.37a3.08,3.08,0,0,1-1-.14A3.31,3.31,0,0,1,33.43,4.1a3.27,3.27,0,0,1,1.6-2,3.33,3.33,0,0,1,4.51,1.35A3.34,3.34,0,0,1,38.19,8,3.25,3.25,0,0,1,36.61,8.37Zm0-5.25a1.88,1.88,0,0,0-.92.23,1.92,1.92,0,0,0-.93,1.14,1.93,1.93,0,1,0,3.55-.36,1.91,1.91,0,0,0-1.15-.93A1.75,1.75,0,0,0,36.61,3.12Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M181.89,151.51c13.69-3.9,26.8-10.65,28.42-17.55a1.49,1.49,0,0,0,0-.63L187.38,14a1.5,1.5,0,0,0-1.76-1.19,1.52,1.52,0,0,0-1.19,1.76l22.88,119c-1.74,5.62-15.48,12.79-31.68,16.44-11.76,2.64-21.34,2.44-24-.49L108.35,36.25a1.51,1.51,0,1,0-2.82,1.08L148.9,150.82a1.27,1.27,0,0,0,.23.41c4.78,6,20.59,3.18,27.16,1.7C178.15,152.52,180,152,181.89,151.51Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M105.49,37.2c-1.51-5.3,27-14,39.26-17.53s41.09-11.08,42.6-5.78-26.95,14-39.25,17.53S107,42.5,105.49,37.2Zm40.09-14.63c-20,5.68-32.88,11.08-36.35,13.57,4.26.28,18.07-1.93,38-7.62S180.14,17.44,183.61,15C179.36,14.67,165.55,16.88,145.58,22.57Z"
}), React.createElement("path", {
  className: "cmb-1",
  d: "M133.59,31.2c.64,0,1.29,0,1.93,0,2.59.12,5.18.47,7.76.85a30.24,30.24,0,0,0,7.69.54c4.85-.55,9.22-2.8,13.65-4.71s12.75-8.11,17-2.13a1.05,1.05,0,0,0,.46.39l19.23,103.35c-12.35,13.11-35,19.06-47.19,13.44L113.79,36.84Z"
}), React.createElement("g", {
  className: "cmb-6"
}, React.createElement("path", {
  className: "cmb-4",
  d: "M127.73,42.23c5.42-.36,10.74,1.59,11.38,1.6,2.56,0,5.12.28,7.67.54a32.4,32.4,0,0,0,7.62.28c4.82-.63,9.22-2.78,13.66-4.63s12.88-7.67,16.94-2.39a1,1,0,0,0,.45.33l16.18,92.66c-12.62,12.16-35.28,18.16-47.19,13.44l-40.1-98S122.32,42.6,127.73,42.23Z"
})), React.createElement("path", {
  className: "cmb-5",
  d: "M119,26.92a8.82,8.82,0,0,1,1.23-.22,8.12,8.12,0,0,1,3.61-5.11,8.09,8.09,0,0,1,15.05-4,6.26,6.26,0,0,1,9.82-.94l.12,0h0A6.3,6.3,0,0,1,161,13.51a6.27,6.27,0,0,1,3,1,6.29,6.29,0,0,1,10.6,2.68,6,6,0,0,1,.19,1,6.33,6.33,0,1,1-1.6,11.52,8,8,0,0,1-9.55,4.57,10.33,10.33,0,0,1-18.16,1.17.71.71,0,0,1-.14-.1,8,8,0,0,1-3.26,1.87,8.11,8.11,0,0,1-4.12,0,8.13,8.13,0,0,1-5.52,5.31,8,8,0,0,1-6.76-1.11,7.91,7.91,0,0,1-2.25,1.07A8.14,8.14,0,1,1,119,26.92Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M157.47,41.3a11.69,11.69,0,0,1-12.38-3.94,9.18,9.18,0,0,1-6.27,1.52,9.46,9.46,0,0,1-13.15,4.26,8.19,8.19,0,0,1-1.86.78,9.54,9.54,0,1,1-5.23-18.35,4.7,4.7,0,0,1,.51-.12,9.49,9.49,0,0,1,3.35-4.63,9.49,9.49,0,0,1,16.49-5.49,7.82,7.82,0,0,1,8.55-1.27A7.7,7.7,0,0,1,162,12.22a7.3,7.3,0,0,1,1.84.58,7.57,7.57,0,0,1,2.59-1.32,7.76,7.76,0,0,1,9.51,5.13,7.74,7.74,0,0,1,2.65,15.16,7.64,7.64,0,0,1-4.75-.18,9.53,9.53,0,0,1-9.41,4.32A11.81,11.81,0,0,1,157.47,41.3ZM144.94,34a1.42,1.42,0,0,1,1.29.28,1.86,1.86,0,0,1,.42.42,8.92,8.92,0,0,0,15.7-1A1.42,1.42,0,0,1,164,33a6.71,6.71,0,0,0,7.9-3.78,1.37,1.37,0,0,1,.86-.77,1.36,1.36,0,0,1,1.15.13,4.86,4.86,0,0,0,3.86.52,4.92,4.92,0,0,0-2.63-9.49,1.38,1.38,0,0,1-1.15-.19,1.42,1.42,0,0,1-.61-1,4.63,4.63,0,0,0-.14-.8,4.94,4.94,0,0,0-6.09-3.39A4.83,4.83,0,0,0,165,15.5a1.41,1.41,0,0,1-1.77.19,5,5,0,0,0-2.35-.78,1.41,1.41,0,0,1-1.23-.93,4.89,4.89,0,0,0-9.45,2.4A1.41,1.41,0,0,1,149.13,18a1.52,1.52,0,0,1-1.46-.34,4.85,4.85,0,0,0-7.63.73,1.44,1.44,0,0,1-1.2.64,1.4,1.4,0,0,1-1.18-.69,6.69,6.69,0,0,0-12.45,3.32,1.39,1.39,0,0,1-.66,1.16,6.72,6.72,0,0,0-3,4.23,1.38,1.38,0,0,1-1.2,1.09,6.06,6.06,0,0,0-1,.18,6.73,6.73,0,1,0,5.54,12,1.42,1.42,0,0,1,1.57,0,6.68,6.68,0,0,0,10.15-3.47,1.41,1.41,0,0,1,1.67-.93,6.48,6.48,0,0,0,6.1-1.58A1.43,1.43,0,0,1,144.94,34Z"
}), React.createElement("path", {
  className: "cmb-2",
  d: "M148.1,31.42c12.3-3.51,40.76-12.23,39.25-17.53a1.5,1.5,0,0,0-2.95.37c-1.58,2-15,8-37.13,14.26S110.61,36.85,108.2,36a1.51,1.51,0,0,0-2.71,1.24C107,42.5,135.79,34.92,148.1,31.42Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 170.95,
  cy: 86.08,
  r: 2.93
}), React.createElement("path", {
  className: "cmb-2",
  d: "M170.94,89.78a3.71,3.71,0,1,1,3.71-3.7A3.7,3.7,0,0,1,170.94,89.78Zm0-5.86a2.16,2.16,0,1,0,2.16,2.16A2.16,2.16,0,0,0,170.94,83.92Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 171.09,
  cy: 58.58,
  r: 2.74
}), React.createElement("path", {
  className: "cmb-2",
  d: "M171.09,62a3.46,3.46,0,1,1,3.46-3.47A3.47,3.47,0,0,1,171.09,62Zm0-5.48a2,2,0,1,0,2,2A2,2,0,0,0,171.09,56.56Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 184.67,
  cy: 66.99,
  r: 2.63
}), React.createElement("path", {
  className: "cmb-2",
  d: "M184.67,70.32A3.33,3.33,0,1,1,188,67,3.33,3.33,0,0,1,184.67,70.32Zm0-5.26A1.93,1.93,0,1,0,186.6,67,1.94,1.94,0,0,0,184.67,65.06Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 163.32,
  cy: 5.12,
  r: 2.93
}), React.createElement("path", {
  className: "cmb-2",
  d: "M163.32,8.83A3.71,3.71,0,1,1,167,5.12,3.72,3.72,0,0,1,163.32,8.83Zm0-5.86a2.15,2.15,0,1,0,2.15,2.15A2.15,2.15,0,0,0,163.32,3Z"
}), React.createElement("circle", {
  className: "cmb-5",
  cx: 180.56,
  cy: 4.82,
  r: 2.63
}), React.createElement("path", {
  className: "cmb-2",
  d: "M180.56,8.14a3.33,3.33,0,1,1,3.32-3.32A3.32,3.32,0,0,1,180.56,8.14Zm0-5.25a1.93,1.93,0,1,0,1.93,1.93A1.93,1.93,0,0,0,180.56,2.89Z"
})));

var SvgCheersMakingBeer = function SvgCheersMakingBeer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 210.36 154.89",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheersMakingBeer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CheersMakingBeer.a7f31b84.svg";
export { ForwardRef as ReactComponent };